import styled, { css } from 'styled-components'

export const InactivityOverlay = styled.button`
  position: fixed;
  inset: 0;
  z-index: 1500;
  border: 0;
  padding: 0;
  width: 100%;
  background: rgba(44, 48, 85, 0.95);
  backdrop-filter: blur(30px);
  color: ${props => props.theme.color.inverted};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  ${props =>
    props.theme.contrastMode &&
    css`
      background: rgba(0, 0, 0, 0.95);
    `};
`

export const InactivityContent = styled.div`
  width: min(36rem, 92vw);
  display: flex;
  flex-direction: column;
  align-items: center;

  > p {
    font-size: 1.75rem;
    font-weight: 500;
  }
`

export const InactivityTimer = styled.div`
  width: min(31rem, 72vw);
  aspect-ratio: 1 / 1;
  position: relative;
  margin-bottom: 2rem;
`

export const InactivityTimerSvg = styled.svg`
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);

  circle {
    &:first-child {
      stroke: rgba(255, 255, 255, 0.2);
    }
    &:nth-child(2) {
      stroke: ${props => props.theme.color.inverted};
    }
  }
`

export const InactivityTimerContent = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 500;
    opacity: 0.5;
  }

  strong {
    line-height: 1;
    margin-top: 0.5rem;
    font-size: 6rem;
    font-weight: 500;
  }
`
